import { createFeatureActionNamer } from '../redux/action-name';

const getActionName = createFeatureActionNamer('duck');

export default {
    TOGGLE: getActionName('TOGGLE'),
};
